import { mapState, mapActions, mapGetters } from "vuex";
import AppIcon from "@/components/AppIcon";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";
import AppPopover from "@/components/AppPopover";
import LoadingElement from "@/components/shared/LoadingElement.vue";
import { country_codes_with_flags_and_marketplace_ids } from "@/utils/countries";
import BrandPortfolioMixin from "@/mixins/BrandPortfolioMixin.vue";
export default {
  name: "BrandPortfolioWorkspaceNameCell",
  components: {
    AppIcon,
    ChevronDownIcon,
    ChevronRightIcon,
    AppPopover,
    LoadingElement
  },
  mixins: [BrandPortfolioMixin],
  emits: ["onWorkspaceAlertClickHandler", "onSellerNameClickHandler"],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    portfolio: {
      type: Object,
      default: {}
    },
    isLastSellerInWorkspace: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      accounts: state => state.account.list,
      workspaces: state => state.workspace.list
    }),
    ...mapGetters(["getCountryFlag"])
  },
  methods: {
    workspaceNameForBrandPortfolio(workspace_id) {
      return this.workspaces.find(workspace => workspace.workspace_id == workspace_id)?.workspace_name ?? "-";
    },
    formatAlertCount(count) {
      return count > 99 ? "+99" : count;
    },
    onWorkspaceAlertClickHandler(workspace_id) {
      this.$emit("onWorkspaceAlertClickHandler", workspace_id);
    },
    getCountryCode(sales_channel) {
      const countryCode = country_codes_with_flags_and_marketplace_ids.find(marketplace => marketplace?.sales_channel?.toLowerCase() === sales_channel?.toLowerCase())?.country_code;
      return countryCode;
    },
    onSellerNameClickHandler(workspace_id, seller_id) {
      this.$emit("onSellerNameClickHandler", workspace_id, seller_id);
    }
  }
};